import { Outlet } from 'react-router';

import { ActiveCharacterBanner } from '../components/ActiveCharacterBanner';
import { NavBar } from '../components/NavBar';
import styles from './Layout.module.css';

/**
 * Root layout shared by every route. Holds the page header (title +
 * subtitle), the primary NavBar, and an <Outlet /> for the active route's
 * content. The header subtitle is intentionally pinned to the current
 * Step so reviewers can spot version drift at a glance.
 *
 * Phase 3 Step 6 (1/4).
 */
export function Layout() {
  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <h1 className={styles.title}>Renavora Client</h1>
        <p className={styles.subtitle}>Local combat lab and character hub.</p>
      </header>
      <ActiveCharacterBanner />
      <NavBar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
